import { render, staticRenderFns } from "./campaign-write.vue?vue&type=template&id=0a248319&"
import script from "./campaign-write.vue?vue&type=script&lang=js&"
export * from "./campaign-write.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports